import React, { ReactElement } from 'react';
import Table from '../../../../components/table/table.component';
import TableBody from '../../../../components/table-body/table-body.component';
import TableRow from '../../../../components/table-row/table-row.component';
import TableCell from '../../../../components/table-cell/table-cell.component';
import FormFieldCheckbox from '../../../../components/form-field-checkbox/form-field-checkbox.component';
import SinglePageTab from '../../../app/common/single-page-tab/single-page-tab.component';
import FormatService from '../../../../services/format-service';
import { SETTING_NAME_SHOW_ACCOUNT_LOGO } from '../../../../constants/entity/setting-names';

const SettingsAccountPreferences: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isSaving,
    isSaveDisabled,
    isEditMode,
    isRightDrawerOpen,
    accountSettingsMap,
    formError,
    onCancelForm,
    onSubmitForm,
  } = props;

  const isEmpty: boolean = !accountSettingsMap || !accountSettingsMap[SETTING_NAME_SHOW_ACCOUNT_LOGO];
  const formPrefix: string = 'accountSettings';

  return (
    <SinglePageTab
      isSaving={isSaving}
      isSaveDisabled={isSaveDisabled}
      isEditMode={isEditMode}
      isRightDrawerOpen={isRightDrawerOpen}
      isEmpty={isEmpty}
      formError={formError}
      onCancelForm={onCancelForm}
      onSubmitForm={onSubmitForm}
    >
      <Table>
        <TableBody isPlain withNoBorders withTwoColumns withHeaderColumn>
          <TableRow>
            <TableCell>
              Show Account Logo
            </TableCell>
            <TableCell>
              {
                isEditMode ? (
                  <FormFieldCheckbox name={`${formPrefix}[${SETTING_NAME_SHOW_ACCOUNT_LOGO}].value`} />
                ) : FormatService.formatBooleanValue(
                  (accountSettingsMap && accountSettingsMap[SETTING_NAME_SHOW_ACCOUNT_LOGO].value) || false,
                )
              }
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </SinglePageTab>
  );
});

export default SettingsAccountPreferences;
